import request from '@/utils/request.js'

export default {
    //登陆
    login: params => request.post('users/sign-in', params),

    signOut: params => request.post('users/sign-out', params),
    // 获取个人信息
    userInfo: params => request.get('users/profile', params),
    // 修改个人信息
    editUser: params => request.post('users/profile/edit', params),
    // 修改密码
    editPassword: params => request.post('users/profile/password/edit', params),
    // 获取用户列表
    userList: params => request.get('users', { params }),
    // 保存用户
    addUser: params => request.post('users/save', params),
    // 保存用户
    deleteUser: params => request.post(`/users/${params}/delete`),
    // 分页获取角色列表
    getRoles: params => request.get('sys/roles', { params }),
    // 保存角色信息
    saveRolesInfo: params => request.post('sys/roles/save', params),
    // 获取角色详情
    getRolesDetail: params => request.get(`sys/roles/${params.id}`),
    // 删除角色
    deleteRoles: params => request.post(`sys/roles/${params.id}/remove`),
    // 获取用户权限列表
    getPermissions: params => request.get('users/permissions', { params }),
    //登陆成功，可以开始推送
    beginPush: params => request.post('users/push-id', params),
    //获取(硬件部分)消息类型
    getMessageType: params => request.get('/hardware/task/list/task-type', params),
    //重置密码
    resetUserPassword: (userId) => request.post(`users/resetUserPassword/${userId}`),
}


// WEBPACK FOOTER //
// ./src/api/user/index.js